// extracted by mini-css-extract-plugin
export default {"card":"Skeleton_card__Iw3FQ","pulse":"Skeleton_pulse__-siLx","image":"Skeleton_image__9+vXF","line":"Skeleton_line__CoKlF","lineSmall":"Skeleton_lineSmall__tv6bU"};